import { useCallback, useEffect, useState } from "react";
import { useBeforeUnload, useNavigate } from "react-router-dom";
import { ConfirmDialog } from "@/components/admin/ConfirmDialog";

export const UnsavedChanges = ({ dirty }) => {
  const [next, setNext] = useState(null);
  const navigate = useNavigate();
  useBeforeUnload(useCallback((event) => { if (dirty) { event.preventDefault(); event.returnValue = ""; } }, [dirty]));
  useEffect(() => {
    const handle = (event) => {
      if (!dirty || event.ctrlKey || event.metaKey) return;
      const anchor = event.target.closest("a");
      if (!anchor || anchor.target === "_blank" || !anchor.href.startsWith(window.location.origin) || anchor.href === window.location.href) return;
      event.preventDefault(); event.stopPropagation(); setNext(new URL(anchor.href).pathname);
    };
    document.addEventListener("click", handle, true);
    return () => document.removeEventListener("click", handle, true);
  }, [dirty]);
  return <ConfirmDialog open={!!next} onClose={() => setNext(null)} onConfirm={() => { const path = next; setNext(null); navigate(path); }} title="Leave without saving?" description="Your latest changes have not been saved." confirmLabel="Discard changes" testid="unsaved-confirm" />;
};